import React from 'react';
import { Container, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import LanguageToggle from '../LanguageToggle';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isReadyPage = location.pathname === '/ready';
  const showLanguageToggle =
    location.pathname !== '/admin' &&
    location.pathname !== '/guide' &&
    !isReadyPage;
  const isLb1Page = location.pathname === '/lb1';
  const isQuizPage = location.pathname === '/guide';
  const noPadding = isLb1Page || isQuizPage || isReadyPage;
  const noContainerPadding = isQuizPage || isReadyPage;

  // The readiness quiz paints its own dark field edge to edge, so it takes
  // neither the white sheet nor the lg container: the sheet showed as white
  // margins around it, and the container capped it at 1200px on wide screens.
  if (isReadyPage) {
    return <Box sx={{ minHeight: '100vh', bgcolor: '#1d2024' }}>{children}</Box>;
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: noPadding ? 'white' : 'background.default' }}>
      {showLanguageToggle && <LanguageToggle />}
      <Container maxWidth="lg" sx={{ py: noPadding ? 0 : 4, px: noContainerPadding ? 0 : undefined }}>
        {children}
      </Container>
    </Box>
  );
};

export default Layout;